import { PlusIcon } from '@radix-ui/react-icons';
import { Flex } from '@raystack/apsara';

export const CreateNewProjectButton = ({ onClick }) => {
  return (
    <Flex
      style={{
        color: 'var(--rs-color-foreground-accent-primary)',
        gap: 4,
        padding: 'var(--rs-space-2)',
        borderRadius: 'var(--rs-radius-2)',
        cursor: 'pointer',
        marginTop: 'var(--rs-space-2)'
      }}
      onClick={onClick}
      data-test-id='create-new-project'
    >
      <PlusIcon color={'var(--rs-color-foreground-accent-primary)'} />

      <span color={'var(--rs-color-foreground-accent-primary)'}>
        Create new project
      </span>
    </Flex>
  );
};
